import { notification } from "antd";
import {
  DELETE_RESPONSEFORM_REQUEST,
  DELETE_RESPONSEFORM_SUCCESS,
  DELETE_RESPONSEFORM_FAILURE,
} from "../Types";
import { DcOffLineHost } from "../../config";

export const DeletResponseFormActions = (id) => {
  return async (dispatch) => {
    dispatch({ type: DELETE_RESPONSEFORM_REQUEST });

    try {
      const token = localStorage.getItem("token");

      if (!token) {
        throw new Error("Aucun token trouvé, veuillez vous reconnecter.");
      }

      const response = await fetch(`${DcOffLineHost}api/responses/${id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
      });

      const data = await response.json();
     
      if (!response.ok) {
        throw new Error(data?.message || "Erreur lors de la suppression de la réponse");
    }

      dispatch({ type: DELETE_RESPONSEFORM_SUCCESS, payload: data });

      notification.success({
        message: data?.message,
        duration: 5,
      });
    //   return data;
      
    } catch (error) {
      dispatch({ type: DELETE_RESPONSEFORM_FAILURE, payload: error?.message });

      notification.error({
        message:error?.message || "Erreur lors de la suppression de la réponse",
        duration: 5,
      });
    }
  };
};

